<template>
    <component :is="tag" v-if="renderContainer" v-show="animate || show" :class="['fold-container', {animate, open: show}]">
        <div v-if="animate" class="fold-container-content" :aria-hidden="!show">
            <slot v-bind="slotVariables"/>
        </div>
        <slot v-else v-bind="slotVariables"/>
    </component>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator';

    // @todo: not quite happy with the folding-solution -> consider to rather add listeners to children as it was handled before instead of using the store
    @Component({
        name: 'FoldContainer',
    })
    /**
     * @deprecated
     */
    export default class FoldContainer extends Vue
    {
        @Prop({
            type: String,
            default: 'div',
            required: false,
        }) tag: string;

        @Prop({
            type: String,
            required: true,
        }) group: string;

        @Prop({
            type: Boolean,
            default: false,
            required: false,
        }) defaultOpen: boolean;

        @Prop({
            type: Boolean,
            default: true,
            required: false,
        }) renderClosed: boolean;

        @Prop({
            type: Boolean,
            default: false,
            required: false,
        }) showOpen: boolean;

        @Prop({
            type: Boolean,
            default: false,
            required: false,
        }) showClosed: boolean;

        @Prop({
            type: Boolean,
            default: false,
            required: false,
        }) animate: boolean;

        get slotVariables()
        {
            return {
                open: this.open,
                toggle: this.toggle,
            };
        }

        get renderContainer(): boolean
        {
            return this.animate || this.renderClosed || this.show;
        }

        get show(): boolean
        {
            return this.showOpen && this.open || this.showClosed && !this.open || !this.showOpen && !this.showClosed;
        }

        get open(): boolean
        {
            return !!this.$store.state.foldContainer[this.group];
        }

        created()
        {
            if (typeof this.$store.state.foldContainer[this.group] === 'undefined' && this.defaultOpen)
            {
                this.$store.dispatch('setFold', {group: this.group, openState: true});
            }
        }

        toggle()
        {
            this.$store.dispatch('toggleFold', this.group);
        }
    };
</script>